import React from 'react';
import PropTypes from 'prop-types';

import EditIcon from '@icons/EditIcon';
import CardMemberAvatar from '@atoms/CardMemberAvatar';
import useStrengthModal from '../../../hooks/useStrengthModal';
import useViewer from '@hooks/useViewer';

// Avatar and edit icon - used on dashboad and edit profile
// uses whole viewer query to save adding another request
const EditProfilePictureLink = ({ showEditIcon = false, sizeMobile = 80, sizeDesktop = 180 }) => {
    const { viewer } = useViewer();
    const { openStrengthModal } = useStrengthModal();

    if (!viewer) return null;

    const { firstName, lastName, photoUrl, fullName } = viewer;
    // remove this eventually? fix for weird issue where photo is http, probably just a one-off on staging - all should be https
    const photo = photoUrl?.includes('http://') ? photoUrl.replace('http://', 'https://') : photoUrl;

    const handleAvatarClick = () => {
        openStrengthModal('edit-pic');
    };

    return (
        <a
            role="button"
            tabIndex={0}
            style={{ pointer: 'cursor', position: 'relative' }}
            onClick={handleAvatarClick}
            onKeyDown={handleAvatarClick}
        >
            {showEditIcon && (
                <div style={{ position: 'absolute', right: '-16px', top: '-8px' }}>
                    <EditIcon />
                </div>
            )}

            <CardMemberAvatar
                photoURL={photo}
                firstName={firstName}
                lastName={lastName}
                fullName={fullName}
                sizeMobile={sizeMobile}
                sizeDesktop={sizeDesktop}
            />
        </a>
    );
};

EditProfilePictureLink.propTypes = {
    showEditIcon: PropTypes.bool,
    sizeMobile: PropTypes.number,
    sizeDesktop: PropTypes.number,
};

export default EditProfilePictureLink;
